import React from 'react'
import type { ComponentProps, PartData } from '@enonic/react-components'
import HeroFrontpage from './prototype/HeroFrontpage'

type HeroInteractiveCta = {
	label: string
	href: string
	isExternal: boolean
}

type HeroInteractivePartData = {
	title?: string
	intro?: string
	primaryCta?: HeroInteractiveCta
	secondaryCta?: HeroInteractiveCta
	stats?: { value?: string; label?: string }[]
}

export const HeroInteractive = ({ data }: ComponentProps<PartData>) => {
	const { title, intro, primaryCta, secondaryCta, stats = [] } = (data || {}) as HeroInteractivePartData

	return (
		<HeroFrontpage
			title={title || ''}
			intro={intro}
			primaryCta={primaryCta}
			secondaryCta={secondaryCta}
			stats={stats.map((stat) => ({ value: stat.value || '', label: stat.label || '' }))}
		/>
	)
}
